﻿export class PostFilters {

    public static clickHandler($: JQueryStatic): void {

        $('.post-filter-mobile-container').on('click', function () {

            $('.posts-filter-container').slideToggle();

        });

    }
    
}